import axios from "axios";
import { API_URL } from "../config";
import authService from "./auth";

const consumidorFlorestalService = {
  listar: async (filtros = {}) => {
    try {
      const response = await axios.get(`${API_URL}consumidor-florestal/`, {
        headers: authService.getAuthHeader(),
        params: filtros,
      });
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || {
          detail: "Erro ao listar consumidores florestais",
        }
      );
    }
  },

  criar: async (dados) => {
    try {
      const response = await axios.post(
        `${API_URL}consumidor-florestal/`,
        dados,
        {
          headers: authService.getAuthHeader(),
        }
      );
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || { detail: "Erro ao criar consumidor florestal" }
      );
    }
  },

  atualizar: async (id, dados) => {
    try {
      const response = await axios.put(
        `${API_URL}/consumidor-florestal/${id}/`,
        dados,
        {
          headers: authService.getAuthHeader(),
        }
      );
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || {
          detail: "Erro ao atualizar consumidor florestal",
        }
      );
    }
  },

  excluir: async (id) => {
    try {
      await axios.delete(`${API_URL}/consumidor-florestal/${id}/`, {
        headers: authService.getAuthHeader(),
      });
    } catch (error) {
      throw (
        error.response?.data || {
          detail: "Erro ao excluir consumidor florestal",
        }
      );
    }
  },
};

export default consumidorFlorestalService;
